module.exports = __webpack_public_path__ + "static/media/icon-gear.ad82857f.svg";